import { YesNoQuestion as YesNoQuestionField } from '@onegov/react-component-library';
import { FormYesNoQuestionProps } from './types';
import { PropsWithController } from '../types';

export const FormYesNoQuestion = ({ questionKey, text, field, fieldState, formState, ...questionProps } : PropsWithController<FormYesNoQuestionProps>) => {
  return (
    <YesNoQuestionField
      id={questionKey}
      {...questionProps}
      {...field}
      label={text}
      errorMessage={fieldState.error?.message}
    />
  );
};

FormYesNoQuestion.defaultProps = {
  vertical: true,
};
